"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _reactHelmet = require("react-helmet");

var _peractoUi = require("@peracto/peracto-ui");

var _client = require("@peracto/client");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ArticleCategoriesList = function ArticleCategoriesList() {
  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedColumns = _useState2[0],
      onSelectColumn = _useState2[1];

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client; // The 'selectable' property is used to define if the
  // column is available in the 'manage columns' dropdown


  var columns = (0, _react.useMemo)(function () {
    return [{
      id: 'selection',
      Header: function Header(_ref) {
        var getToggleAllRowsSelectedProps = _ref.getToggleAllRowsSelectedProps;
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.StyledCheckbox, getToggleAllRowsSelectedProps());
      },
      Cell: function Cell(_ref2) {
        var row = _ref2.row;
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.StyledCheckbox, _extends({}, row.getToggleRowSelectedProps(), {
          "data-testid": "row-".concat(row.index, "-checkbox")
        }));
      },
      selectable: false
    }, {
      Header: 'Name',
      accessor: 'name',
      sortType: 'basic',
      Filter: function Filter(props) {
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.TextFilter, _extends({
          label: "Name"
        }, props));
      },
      Cell: function Cell(row) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: row.row.original.id
        }, row.cell.value);
      },
      selectable: false
    }, {
      Header: 'Title',
      accessor: 'title',
      sortType: 'basic',
      Filter: function Filter(props) {
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.TextFilter, _extends({
          label: "Title"
        }, props));
      },
      selectable: false
    }, {
      Header: 'Locale',
      accessor: 'locale',
      sortType: 'basic',
      Filter: function Filter(props) {
        return /*#__PURE__*/_react["default"].createElement(_peractoUi.TextFilter, _extends({
          label: "Locale"
        }, props));
      },
      selectable: false
    }];
  });

  var onFetchData = function onFetchData(options) {
    return client(_client.GET_LIST, 'article-categories', options);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("title", null, "Article Categories | Peracto")), /*#__PURE__*/_react["default"].createElement(_peractoUi.Heading, {
    name: "Article Categories"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-center ml-2"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: "btn btn-primary",
    to: "/article-categories/add",
    "data-testid": "add-article-category"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlusCircle.faPlusCircle,
    className: "mr-2"
  }), "Add Article Category"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card card--transparent"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react["default"].createElement(_peractoUi.HydraTable, {
    columns: columns,
    selectedColumns: selectedColumns,
    onFetchData: onFetchData,
    onSelectColumn: onSelectColumn,
    defaultFilters: {
      name: '',
      title: '',
      locale: ''
    }
  }))))));
};

var _default = ArticleCategoriesList;
exports["default"] = _default;